// export enum LogEventType {
//   REQUEST_CONTACT,
//   SEARCH_RESULTS,
//   DETAIL_VIEW,
//   PERMALINK_VIEW,
//   COMPARISON,

//   REQUEST_SAMPLE,
//   REQUEST_QUOTE,
//   REQUEST_DOCUMENT,
//   REQUEST_DOWNLOAD,
//   ADD_PRODUCT_TO_PROJECT,

//   EXTERNAL_WEBPAGE,

//   OPENED_REQUEST_CONTACT,
//   OPENED_REQUEST_SAMPLE,
//   OPENED_REQUEST_QUOTE,
//   OPENED_REQUEST_DOCUMENT,

//   OPENED_PRODUCT_DOWNLOAD
// }

export enum LogEventType {
  CREATE_UPDATE_INGREDIENTS = 'CREATE_UPDATE_INGREDIENTS',
  CREATE_UPDATE_FORMULATIONS = 'CREATE_UPDATE_FORMULATIONS',
  CREATE_UPDATE_SERVICES = 'CREATE_UPDATE_SERVICES',
  CREATE_UPDATE_COMPANY_PROFILE = 'CREATE_UPDATE_COMPANY_PROFILE',
  PRODUCT_IMPRESSION = 'PRODUCT_IMPRESSION',
  PRODUCT_DETAIL = 'PRODUCT_DETAIL',
  PRODUCT_PERMALINK = 'PRODUCT_PERMALINK',
  PRODUCT_EXTERNAL_WEBPAGE = 'PRODUCT_EXTERNAL_WEBPAGE',
  PRODUCT_COMPARED = 'PRODUCT_COMPARED',
  BOOKMARK_ADDED = 'BOOKMARK_ADDED', // is not used by UI, event is logged from endpoint '/ingredients/bookmarks'
  REQUEST_CONTACT = 'REQUEST_CONTACT',
  REQUEST_SAMPLE = 'REQUEST_SAMPLE',
  ADD_PRODUCT_TO_PROJECT = 'ADD_PRODUCT_TO_PROJECT',
  REQUEST_QUOTE = 'REQUEST_QUOTE',
  REQUEST_DOCUMENT = 'REQUEST_DOCUMENT',
  PRODUCT_DOWNLOAD = 'PRODUCT_DOWNLOAD',

  FORMULATION_IMPRESSION = 'FORMULATION_IMPRESSION',
  FORMULATION_DETAIL = 'FORMULATION_DETAIL',
  FORMULATION_PERMALINK = 'FORMULATION_PERMALINK',
  FORMULATION_BOOKMARK_ADDED = 'FORMULATION_BOOKMARK_ADDED', // is not used by UI, event is logged from endpoint '/formulations/bookmarks'
  FORMULATION_REQUEST_CONTACT = 'FORMULATION_REQUEST_CONTACT',
  FORMULATION_REQUEST_QUOTE = 'FORMULATION_REQUEST_QUOTE',
  FORMULATION_REQUEST_DOCUMENT = 'FORMULATION_REQUEST_DOCUMENT',

  SERVICE_IMPRESSION = 'SERVICE_IMPRESSION',
  SERVICE_DETAIL = 'SERVICE_DETAIL',
  SERVICE_PERMALINK = 'SERVICE_PERMALINK',
  SERVICE_BOOKMARK_ADDED = 'SERVICE_BOOKMARK_ADDED', // is not used by UI, event is logged from endpoint '/services/bookmarks'
  SERVICE_REQUEST_CONTACT = 'SERVICE_REQUEST_CONTACT',

  // CC-1739: temp. event types to monitor opened (vs. submitted) contact forms
  OPENED_REQUEST_CONTACT = 'OPENED_REQUEST_CONTACT',
  OPENED_REQUEST_SAMPLE = 'OPENED_REQUEST_SAMPLE',
  OPENED_REQUEST_QUOTE = 'OPENED_REQUEST_QUOTE',
  OPENED_REQUEST_DOCUMENT = 'OPENED_REQUEST_DOCUMENT',
  OPENED_FORMULATION_REQUEST_CONTACT = 'OPENED_FORMULATION_REQUEST_CONTACT',
  OPENED_FORMULATION_REQUEST_QUOTE = 'OPENED_FORMULATION_REQUEST_QUOTE',
  OPENED_FORMULATION_REQUEST_DOCUMENT = 'OPENED_FORMULATION_REQUEST_DOCUMENT',
  OPENED_SERVICE_REQUEST_CONTACT = 'OPENED_SERVICE_REQUEST_CONTACT',

  // CC-1781: temp. event type to log when the document download dialog is opened
  OPENED_PRODUCT_DOWNLOAD = 'OPENED_PRODUCT_DOWNLOAD',

  ERROR_PAGE_MESSAGE = 'ERROR_PAGE_MESSAGE',

  SEARCH_RESULTS = 'SEARCH_RESULTS',
  DETAIL_VIEW = 'DETAIL_VIEW',
  PERMALINK_VIEW = 'PERMALINK_VIEW',
  COMPARISON = 'COMPARISON',
  REQUEST_DOWNLOAD = 'REQUEST_DOWNLOAD',
  EXTERNAL_WEBPAGE = 'EXTERNAL_WEBPAGE'
}
